<template>
  <div class="role">
    <Header :present-page="presentPage" />
    <a-row class="warp">
      <a-col :span="16">
        <a-row class="top">
          <a-col class="ipt">
            <span>真实姓名</span>
            <a-input
              v-model:value="searchData.roleName"
              placeholder="请输入"
            />
          </a-col>
          <a-col class="operate">
            <a-button
              type="primary"
              @click="search"
            >搜索</a-button>
            <a-button
              type="default"
              @click="reset"
            >重置</a-button>
            <!-- <a-button
              type="default"
              @click="addModalShow"
            >添加</a-button> -->
          </a-col>
          <!-- <a-col>
            <a-dropdown
              :placement="placement"
              :trigger="['click', 'hover']"
            >
              <a
                class="ant-dropdown-link"
                @click.prevent
              >
                <a-button>更多操作</a-button>
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item @click="addModalShow">
                    <a href="javascript:;">添加</a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </a-col> -->
        </a-row>
        <a-table
          rowKey="roleId"
          :columns="columns"
          :data-source="dataSource"
          :pagination="pagination"
          @change="change"
        >
          <template #action="{ record }">
            <!-- <a-button
              type="default"
              @click="addModalShow(record)"
            >添加</a-button> -->
            <a-button
              class="alter"
              @click="addModalShow(record)"
            >绑定</a-button>
            <a-button
              class="del"
              @click="alterModalShow(record)"
            >查看</a-button>
          </template>
        </a-table>
      </a-col>
      <a-col
        class="right"
        :span="8"
      >
        <AddRole
          ref="AddRole"
          :bridgeTree="lineTree"
          @confirm="init"
        />
        <AlterRole
          ref="AlterRole"
          :bridgeTree="lineTree"
          @confirm="init"
        />
        <DelModal
          ref="DelModal"
          @confirm="confirmDel"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/header.vue";
import AddRole from "@/components/alarms/push/add.vue";
import AlterRole from "@/components/alarms/push/alter.vue";
import DelModal from "@/components/delModal.vue";
import { userList } from "@/api/system/system.js";
import { lineTree, bridgeTree } from "@/api/index/index.js";

export default {
  name: "",
  components: {
    Header,
    AddRole,
    AlterRole,
    DelModal
  },
  data() {
    return {
      presentPage: '',
      searchData: {
        roleName: ''
      },
      placement: 'bottomCenter',
      pagination: {
        size: 'small',
        showSizeChanger: true,
        showQuickJumper: true,
        pageSize: 10,
        showTotal: total => `共 ${total} 条`,
        total: 0
      },
      selectedRowKeys: [],
      query: {
        pageNum: 1,
        pageSize: 10
      },
      delQuery: {
        roleIds: ''
      },
      columns: [
        {
          title: '用户名',
          dataIndex: 'userName',
        },
        {
          title: '真实姓名',
          dataIndex: 'realName',
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
        },
        {
          title: '邮箱',
          dataIndex: 'email',
        },
        {
          title: '部门',
          dataIndex: 'deptName',
        },
        {
          title: '操作',
          dataIndex: 'action',
          slots: {
            customRender: 'action',
          },
        },
      ],
      dataSource: [],
      treeData: [],
      lineTree: [],
      bridgeTree: []
    }
  },
  mounted() {
    this.presentPage = this.$route.query.name
    this.init()
    lineTree(this.query).then(res => {
      if (res.code == 200) {
        this.lineTree = res.data
        for (let i = 0; i < this.lineTree.length; i++) {
          res.data[i].name = res.data[i].lineName  // 对应replaceFields
          res.data[i].id = res.data[i].lineId      // 对应replaceFields
          if (!this.lineTree[i].hasBride) { // 判断是否有下级
            this.lineTree[i].isLeaf = true
          }
          // 通过线路id请求桥梁树形数据
          const element = this.lineTree[i]
          element.children = []

          bridgeTree({ lineId: element.lineId }).then(res2 => {
            if (res2.code == 200) {
              for (let i = 0; i < res2.data.length; i++) {
                res2.data[i].name = res2.data[i].bridgeName  // 对应replaceFields
                res2.data[i].id = res2.data[i].brideId      // 对应replaceFields
              }
              element.children = res2.data
              this.bridgeTree = [
                ...res2.data
              ]
            }
          })
        }
      }
    })
  },
  methods: {
    init() {
      userList(this.query).then(res => {
        if (res.code == 200) {
          this.dataSource = res.data.list
          this.pagination.pageSize = res.data.pageSize
          this.pagination.total = res.data.total
        }
      }).catch(res => {
        console.log(res)
      });
    },
    search() {
      this.query.filterDate = this.searchData
      this.init()
    },
    reset() {
      this.searchData.roleName = ''
      this.search()
    },
    addModalShow(record) {
      this.$refs.AlterRole.hide();
      this.$refs.AddRole.show(record);
    },
    alterModalShow(record) {
      this.$refs.AddRole.hide();
      this.$refs.AlterRole.show(record);
    },
    delModalShow(roleId) {
      this.delQuery = {
        roleIds: roleId
      }
      this.$refs.DelModal.show();
    },
    confirmDel() {
      delRole(this.delQuery).then(res => {
        if (res.code == 200) {
          this.init()
          this.$message.success(res.data);
        }
      }).catch(res => {
        console.log(res)
      });
    },
    change(pagination) {
      this.query = {
        pageNum: pagination.current,
        pageSize: pagination.pageSize
      }
      this.init()
    }
  }
};
</script>
<style scoped>
.warp {
  margin: 20px 30px;
}
.top {
  height: 76px;
  margin: 0 20px 0 0;
  padding: 20px 30px;
  line-height: 36px;
  background: #fff;
}

.ipt {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: left;
}
.ipt span {
  margin-right: 10px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #222;
}
.ipt input {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.ant-divider-vertical {
  height: 22px;
  margin: 0 15px;
  background: #dddddd;
}
.ant-select :deep() .ant-select-selector {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selection-item {
  height: 34px;
  line-height: 34px;
}
.operate {
  text-align: left;
}
.operate button:nth-child(1),
.operate button:nth-child(3) {
  width: 80px;
  height: 36px;
  margin: 0 20px;
  color: #fff;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.operate button:nth-child(2) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: #fff;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
}
.ant-dropdown-link button {
  height: 36px;
  background: #fff;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
}

.ipt :deep() .ant-calendar-picker {
  width: 236px;
}
.ipt :deep() .ant-calendar-picker-input {
  width: 100%;
  height: 36px;
  border-radius: 6px;
}
.ant-table-wrapper {
  margin: 0 20px 0 0;
}
.ant-table-wrapper :deep() .ant-table-thead > tr > th,
.ant-table-wrapper :deep() .ant-table table {
  text-align: center;
}
.ant-table-wrapper .ant-btn {
  width: 66px;
  height: 24px;
  padding: 0;
  margin: 0 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  border-radius: 4px;
}
.look,
.alter {
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
}
.del {
  color: #ff4444;
  background: #fff;
  border: 1px solid #ff4444;
}
.right {
  padding: 22px;
  background: #fff;
}
.right :deep() h5 {
  padding-left: 10px;
  text-align: left;
  vertical-align: top;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: #222;
  border-left: 5px solid #0088ff;
}
.right :deep() .ipt {
  align-items: flex-start;
}
.right :deep() .ipt input {
  width: 100%;
}
.right :deep() .a-btn {
  text-align: right;
}
.right :deep() .ant-form-item-label > label::after {
  content: " ";
}
.right :deep() .cancel {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
  border-radius: 6px;
}
.right :deep() .confirm {
  width: 80px;
  height: 36px;
  color: #fff;
  border: 0;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
</style>
